import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "multisidebar-content__main" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MultisidebarHeader = _resolveComponent("MultisidebarHeader")!
  const _component_NTabs = _resolveComponent("NTabs")!
  const _component_NForm = _resolveComponent("NForm")!
  const _component_MultisidebarSaveActions = _resolveComponent("MultisidebarSaveActions")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_MultisidebarHeader, {
      label: _ctx.model.item.name,
      onAction: _ctx.handleAction,
      actions: _ctx.headerActions
    }, null, 8, ["label", "onAction", "actions"]),
    (_ctx.tabItems)
      ? (_openBlock(), _createBlock(_component_NTabs, {
          key: 0,
          items: _ctx.currentTabItems,
          modelValue: _ctx.tab,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tab) = $event)),
          class: "multisidebar-content__tabs control-m"
        }, null, 8, ["items", "modelValue"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(), _createBlock(_component_NForm, {
        layout: _ctx.sidebarForm,
        model: _ctx.model.item,
        key: `${_ctx.model.item.id}-${_ctx.tab}`,
        disabled: !_ctx.computedModelAcl.update,
        ref: "form"
      }, null, 8, ["layout", "model", "disabled"]))
    ]),
    _createVNode(_component_MultisidebarSaveActions, {
      "model-acl": _ctx.computedModelAcl,
      "sidebar-item": _ctx.sidebarItem
    }, null, 8, ["model-acl", "sidebar-item"])
  ]))
}